var _defs, _style, _rect, _g, _line, _line2, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blurFilter",
    x: "-20%%",
    y: "-20%%",
    width: "140%%",
    height: "140%%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .bg { fill: #0c0d0e; }\n    .lattice-line { stroke: #DCCA87; stroke-width: 0.8; opacity: 0.22; }\n    .orbit-ring { stroke: #2B4A54; stroke-width: 1.2; fill: none; stroke-dasharray: 6 6; opacity: 0.3; }\n    .location-target { stroke: #DCCA87; stroke-width: 1.5; fill: none; opacity: 0.45; }\n    .node-glow { fill: #DCCA87; opacity: 0.12; }\n    .node-base { fill: #131517; stroke: #DCCA87; stroke-width: 1.2; }\n    .node-core { fill: #DCCA87; }\n    \n    @keyframes subtlePulse {\n        0% { opacity: 0.2; transform: scale(0.99); }\n        50% { opacity: 0.4; transform: scale(1.01); }\n        100% { opacity: 0.2; transform: scale(0.99); }\n    }\n    .animated-matrix { animation: subtlePulse 5s ease-in-out infinite; transform-origin: center; }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 400,
    height: 400,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "animated-matrix"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "orbit-ring",
    cx: 200,
    cy: 200,
    r: 75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "orbit-ring",
    cx: 200,
    cy: 200,
    r: 125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "orbit-ring",
    cx: 200,
    cy: 200,
    r: 165
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 40,
    x2: 200,
    y2: 360,
    stroke: "#2B4A54",
    strokeWidth: 1,
    opacity: 0.25,
    strokeDasharray: "4 4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 200,
    x2: 360,
    y2: 200,
    stroke: "#2B4A54",
    strokeWidth: 1,
    opacity: 0.25,
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "connections"
  }, /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 238,
    y1: 115,
    x2: 238,
    y2: 144,
    style: {
      opacity: 0.328
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 238,
    y1: 115,
    x2: 176,
    y2: 153,
    style: {
      opacity: 0.22000000000000003
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 219,
    y1: 328,
    x2: 219,
    y2: 329,
    style: {
      opacity: 0.396
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 219,
    y1: 328,
    x2: 207,
    y2: 327,
    style: {
      opacity: 0.36800000000000005
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 231,
    y1: 209,
    x2: 208,
    y2: 194,
    style: {
      opacity: 0.332
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 231,
    y1: 209,
    x2: 238,
    y2: 144,
    style: {
      opacity: 0.236
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 238,
    y1: 144,
    x2: 238,
    y2: 115,
    style: {
      opacity: 0.328
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 238,
    y1: 144,
    x2: 208,
    y2: 194,
    style: {
      opacity: 0.256
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 111,
    y1: 262,
    x2: 123,
    y2: 274,
    style: {
      opacity: 0.35600000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 111,
    y1: 262,
    x2: 119,
    y2: 243,
    style: {
      opacity: 0.34800000000000003
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 146,
    y1: 280,
    x2: 155,
    y2: 260,
    style: {
      opacity: 0.34400000000000003
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 146,
    y1: 280,
    x2: 123,
    y2: 274,
    style: {
      opacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 257,
    y1: 295,
    x2: 219,
    y2: 328,
    style: {
      opacity: 0.27599999999999997
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 257,
    y1: 295,
    x2: 219,
    y2: 329,
    style: {
      opacity: 0.272
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 176,
    y1: 153,
    x2: 208,
    y2: 194,
    style: {
      opacity: 0.268
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 176,
    y1: 153,
    x2: 238,
    y2: 144,
    style: {
      opacity: 0.244
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 219,
    y1: 329,
    x2: 219,
    y2: 328,
    style: {
      opacity: 0.396
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 219,
    y1: 329,
    x2: 207,
    y2: 327,
    style: {
      opacity: 0.36800000000000005
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 91,
    y1: 227,
    x2: 119,
    y2: 243,
    style: {
      opacity: 0.32000000000000006
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 91,
    y1: 227,
    x2: 111,
    y2: 262,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 119,
    y1: 243,
    x2: 111,
    y2: 262,
    style: {
      opacity: 0.34800000000000003
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 119,
    y1: 243,
    x2: 123,
    y2: 274,
    style: {
      opacity: 0.32000000000000006
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 155,
    y1: 260,
    x2: 146,
    y2: 280,
    style: {
      opacity: 0.34400000000000003
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 155,
    y1: 260,
    x2: 123,
    y2: 274,
    style: {
      opacity: 0.31200000000000006
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 318,
    y1: 311,
    x2: 323,
    y2: 253,
    style: {
      opacity: 0.256
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 318,
    y1: 311,
    x2: 257,
    y2: 295,
    style: {
      opacity: 0.244
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 323,
    y1: 253,
    x2: 318,
    y2: 311,
    style: {
      opacity: 0.256
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 323,
    y1: 253,
    x2: 257,
    y2: 295,
    style: {
      opacity: 0.20400000000000001
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 207,
    y1: 327,
    x2: 219,
    y2: 328,
    style: {
      opacity: 0.36800000000000005
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 207,
    y1: 327,
    x2: 219,
    y2: 329,
    style: {
      opacity: 0.36800000000000005
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 123,
    y1: 274,
    x2: 111,
    y2: 262,
    style: {
      opacity: 0.35600000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 123,
    y1: 274,
    x2: 146,
    y2: 280,
    style: {
      opacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 208,
    y1: 194,
    x2: 231,
    y2: 209,
    style: {
      opacity: 0.332
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 208,
    y1: 194,
    x2: 176,
    y2: 153,
    style: {
      opacity: 0.268
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 125,
    y1: 116,
    x2: 176,
    y2: 153,
    style: {
      opacity: 0.244
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "lattice-line",
    x1: 125,
    y1: 116,
    x2: 238,
    y2: 115,
    style: {
      opacity: 0.11599999999999999
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "nodes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 238,
    cy: 115,
    r: 10,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 238,
    cy: 115,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 219,
    cy: 328,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 219,
    cy: 328,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 219,
    cy: 328,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 231,
    cy: 209,
    r: 12.5,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 231,
    cy: 209,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 238,
    cy: 144,
    r: 12.5,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 238,
    cy: 144,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 111,
    cy: 262,
    r: 15,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 111,
    cy: 262,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 146,
    cy: 280,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 146,
    cy: 280,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 146,
    cy: 280,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 257,
    cy: 295,
    r: 17.5,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 257,
    cy: 295,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 257,
    cy: 295,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 176,
    cy: 153,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 176,
    cy: 153,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 176,
    cy: 153,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 219,
    cy: 329,
    r: 15,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 219,
    cy: 329,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 91,
    cy: 227,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 91,
    cy: 227,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 91,
    cy: 227,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 119,
    cy: 243,
    r: 22.5,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 119,
    cy: 243,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 119,
    cy: 243,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 155,
    cy: 260,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 155,
    cy: 260,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 155,
    cy: 260,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 318,
    cy: 311,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 318,
    cy: 311,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 318,
    cy: 311,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 323,
    cy: 253,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 323,
    cy: 253,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 323,
    cy: 253,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 207,
    cy: 327,
    r: 22.5,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 207,
    cy: 327,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 207,
    cy: 327,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 123,
    cy: 274,
    r: 15,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 123,
    cy: 274,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 208,
    cy: 194,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 208,
    cy: 194,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 208,
    cy: 194,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-glow",
    cx: 125,
    cy: 116,
    r: 20,
    filter: "url(#blurFilter)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-base",
    cx: 125,
    cy: 116,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "node-core",
    cx: 125,
    cy: 116,
    r: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hq-locator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "location-target",
    cx: 200,
    cy: 200,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 14,
    fill: "none",
    stroke: "#DCCA87",
    strokeWidth: 0.8,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 6,
    fill: "#DCCA87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindusLogo);
export default __webpack_public_path__ + "static/media/findus_logo.efed0a548110c1aaf0a28dfa9e099dba.svg";
export { ForwardRef as ReactComponent };